import { ReactNode, useCallback } from 'react';
import { Path } from 'history';
import { matchPath } from 'react-router-dom';

import { routes } from 'configs/routes';
import history from 'configs/history';
import { HOME_EXIT } from 'constants/deeplinks';
import { sendEvent } from 'utils/send';
import { isLastPathTemp } from 'utils/historian';

// TODO: Clear tokens on app quit

type TUseNavigation = {
  navigate: (path: Path) => void;
  replacedNavigate: (path: Path) => void;
  goBack: () => void;
  closeApp: () => void;
  isRootPage?: boolean;
  options: {
    headerTitle?: ReactNode;
    headerRight?: ReactNode;
  };
};

const getComponentNameByPath = (currentPage: string): string => {
  const result = Object.entries(routes).find((pair) => {
    return (
      pair[1].path === currentPage ||
      matchPath(currentPage, { path: pair[1].path, exact: true, strict: false })
    );
  })?.[0];
  return result || routes.landing.key;
};

function useNavigation(): TUseNavigation {
  const { pathname } = window.location;
  const currentComponent = getComponentNameByPath(pathname);

  const {
    options: { headerTitle, headerRight },
    isRootPage,
  } = routes[currentComponent];

  function navigate(path: Path): void {
    if (isLastPathTemp()) {
      history.replace(path);
    } else {
      history.push(path);
    }
  }

  function replacedNavigate(path: Path): void {
    history.replace(path);
  }

  function closeApp() {
    sendEvent.close();
    window.location.href = HOME_EXIT;
  }
  const shouldCloseApp = isRootPage || window.history.length === 1;

  const goBack = useCallback(() => {
    if (shouldCloseApp) {
      closeApp();
    } else {
      history.goBack();
    }
  }, [history, shouldCloseApp]);

  return {
    navigate,
    goBack,
    isRootPage: shouldCloseApp,
    closeApp,
    replacedNavigate,
    options: { headerTitle, headerRight },
  };
}

export { useNavigation };
